import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/home",
      name: "Home",
      // component: () => import("@/views/Home.vue"),
      // meta: {
      //   pageTitle: "Početna",
      //   breadcrumb: [
      //     {
      //       text: "Početna",
      //       active: true,
      //     },
      //   ],
      // },
      component: () => import("@/views/Tracking/Index.vue"),
      meta: {
        pageTitle: "Pozicije grla",
        breadcrumb: [
          {
            text: "Pozicije grla",
            active: true,
          },
        ],
      },
    },
    {
      path: "/account",
      name: "AccountIndex",
      component: () => import("@/views/Account/Account.vue"),
      meta: {
        pageTitle: "Podešavanja naloga",
        breadcrumb: [
          {
            text: "Podešavanja naloga",
            active: true,
          },
        ],
      },
    },
    {
      path: "/devices",
      component: () => import("@/layouts/empty/EmptyLayout.vue"),
      children: [
        {
          path: "/",
          name: "DevicesIndex",
          component: () => import("@/views/Devices/Index.vue"),
          meta: {
            pageTitle: "Uređaji",
            breadcrumb: [
              {
                text: "Uređaji",
                active: true,
              },
            ],
          },
        },
        {
          path: "form/:id?",
          name: "DevicesForm",
          component: () => import("@/views/Devices/Form.vue"),
          meta: {
            pageTitle: "",
            breadcrumb: [
              {
                text: "Uređaji",
                to: { name: "DevicesIndex" },
              },
              {
                text: "",
                active: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/cattle",
      component: () => import("@/layouts/empty/EmptyLayout.vue"),
      children: [
        {
          path: "/",
          name: "CattleIndex",
          component: () => import("@/views/Cattle/Index.vue"),
          meta: {
            pageTitle: "Grla",
            breadcrumb: [
              {
                text: "Grla",
                active: true,
              },
            ],
          },
        },
        {
          path: "form/:id?",
          name: "CattleForm",
          component: () => import("@/views/Cattle/Form.vue"),
          meta: {
            pageTitle: "",
            breadcrumb: [
              {
                text: "Grla",
                to: { name: "CattleIndex" },
              },
              {
                text: "",
                active: true,
              },
            ],
          },
        },
        {
          path: "connect-form",
          name: "CattleDeviceForm",
          component: () => import("@/views/CattleDevice/CattleDeviceForm.vue"),
          meta: {
            pageTitle: "Povezivanje uređaja i grla",
            breadcrumb: [
              {
                text: "Grla",
                to: { name: "CattleIndex" },
              },
              {
                text: "Povezivanje uređaja i grla",
                active: true,
              },
            ],
          },
        },
      ],
    },
    // {
    //   path: "/tracking",
    //   name: "TrackingIndex",
    //   component: () => import("@/views/Tracking/Index.vue"),
    //   meta: {
    //     pageTitle: "Pozicije grla",
    //     breadcrumb: [
    //       {
    //         text: "Pozicije grla",
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: "/virtual-fence",
      name: "VirtualFenceIndex",
      component: () => import("@/views/VirtualFence/Index.vue"),
      meta: {
        pageTitle: "Virtuelna ograda",
        breadcrumb: [
          {
            text: "Virtuelna ograda",
            active: true,
          },
        ],
      },
    },
    {
      path: "/settings",
      name: "SettingsIndex",
      component: () => import("@/views/Settings/Index.vue"),
      meta: {
        pageTitle: "Podešavanja",
        breadcrumb: [
          {
            text: "Podešavanja",
            active: true,
          },
        ],
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

export default router;
